'use client';
import { useFormSubmitEvent } from 'hooks/analytics/use-form-submit-event';
import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { sendGAInvalidSerialWithSites } from '../../utils';
import { CatButton, CatHeading } from 'components/blocks-components';
import { Conditional } from '@cat-ecom/pcc-components';
import { normalizeCommerceLink } from 'utils/links';
import { getRelativeURLWithParams } from 'utils/url';
import { CONTACT_DEALER_LINK } from 'constants/links';
import { useEsiteCtx } from 'services/esite/context';
import styles from './non-cat-equipment-toast.module.scss';
import ErrorToast from './error-toast';

export const NonCatEquipmentToast = ({ refferenceApp, storeName }) => {
  const t = useTranslations();
  const { catalogId, langId, storeId } = useEsiteCtx();
  const contactDealerLink = () =>
    normalizeCommerceLink(
      getRelativeURLWithParams(CONTACT_DEALER_LINK, {
        catalogId,
        langId,
        storeId
      })
    );
  const { fireEvent } = useFormSubmitEvent();
  useEffect(() => {
    sendGAInvalidSerialWithSites(refferenceApp, fireEvent);
    window.history.pushState({}, '', window.location.pathname);
  }, [fireEvent, refferenceApp]);

  return (
    <ErrorToast>
      <div className={styles['toast-message_allignment']}>
        <div className="pe-3 text-wrap pb-3 pb-lg-0 pb-blg-0 pb-md-0">
          <CatHeading variant="label">{t('SN_NOT_SUPPORTED_ERROR')}</CatHeading>
        </div>
        <Conditional test={!!storeName}>
          <div slot="after" className="pe-2">
            <CatButton
              type="button"
              className="text-nowrap"
              href={contactDealerLink()}
            >
              <CatHeading variant="label">
                {t('CONTACT_YOUR_DEALER')}
              </CatHeading>
            </CatButton>
          </div>
        </Conditional>
      </div>
    </ErrorToast>
  );
};
